export const MAX_AMOUNT = 2147483647;
export const DISPLAY_COLUMNS = [
    ['code', 'کد محصول', false], ['bought', 'تعداد خرید', true], ['spent', 'مبلغ خرید', true],
    ['sold', 'تعداد فروش', true], ['earned', 'مبلغ فروش', true],
    ['quantityDifference', 'اختلاف تعداد', true], ['amountDifference', 'اختلاف مبلغ', true],
];
export const money = value => Number(value).toLocaleString('fa-IR', { maximumFractionDigits: 2 });
export function normalized(value) {
    return String(value ?? '').replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
        .replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)).replace(/[يى]/g, 'ی').replace(/ك/g, 'ک').trim();
}
export const JOURNAL_COLUMNS = [
    ['transaction', 'کد تراکنش', true], ['order', 'کد سفارش', true], ['type', 'نوع', true],
    ['productCode', 'کد کالا', false], ['product', 'کالا', true], ['quantity', 'تعداد', true],
    ['unit', 'قیمت واحد', false], ['date', 'تاریخ', true], ['total', 'مبلغ (تومان)', true],
];
export const journalColumns = () => Object.fromEntries(JOURNAL_COLUMNS.map(([key, , visible]) => [key, visible]));
export function positiveInteger(value) {
    const text = normalized(value).replace(/[,٬]/g, '');
    return /^\d+$/.test(text) && Number.isSafeInteger(Number(text)) && Number(text) > 0 && Number(text) <= MAX_AMOUNT ? Number(text) : null;
}
export function calculatePurchase({ quantity, amount, priceMode }) {
    const count = positiveInteger(quantity), entered = positiveInteger(amount);
    if (!count || !entered) return { count, total: null, unit: null };
    const total = priceMode === 'unit' ? count * entered : entered;
    if (!Number.isSafeInteger(total) || total > MAX_AMOUNT) return { count, total: null, unit: null };
    return { count, total, unit: total / count };
}
export function todayTehran(now = new Date()) {
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Tehran', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}
export function purchaseErrors(form, products = []) {
    const result = calculatePurchase(form), errors = {};
    if (!products.some(p => p.id === String(form.productId) && p.stockable && p.active)) errors.productId = 'کالای فعال و انبارشونده را انتخاب کنید.';
    if (!result.count) errors.quantity = 'تعداد باید عدد صحیح بیشتر از صفر باشد.';
    if (!result.total) errors.amount = `مبلغ صحیح بین ۱ و ${money(MAX_AMOUNT)} تومان وارد کنید.`;
    if (!['unit', 'total'].includes(form.priceMode)) errors.amount = 'روش ورود مبلغ را انتخاب کنید.';
    const date = String(form.date || '');
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || Number.isNaN(Date.parse(date)) || new Date(date).toISOString().slice(0, 10) !== date || date > todayTehran()) errors.date = 'تاریخ معتبر، امروز یا قبل از آن را انتخاب کنید.';
    if (String(form.note || '').length > 2000) errors.note = 'جزئیات باید حداکثر ۲۰۰۰ نویسه باشد.';
    return errors;
}
export function purchaseDescription(product, count, total) {
    return product && count && total ? `خرید ${money(count)} عدد ${product.name} — مبلغ کل ${money(total)} تومان` : '—';
}
export function detailUrl(kind, productId, range) {
    const path = '/app/accounting/product-journal';
    return path + '?' + new URLSearchParams({ source: 'product-accounting', kind, productId, from: range.start, to: range.end }).toString();
}
export function parseDetailQuery(query) {
    const p = new URLSearchParams(query || '');
    if (!['product-accounting', 'purchase-ui'].includes(p.get('source')) || !['purchase', 'sale'].includes(p.get('kind')) || !/^[1-9]\d*$/.test(p.get('productId') || '')) return null;
    const from = p.get('from'), to = p.get('to');
    const valid = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '') && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value;
    return valid(from) && valid(to) && from <= to ? { productId: p.get('productId'), kind: p.get('kind'), from, to } : null;
}
